<app-header />
<app-main-banner />
<app-platform-banner />
<app-plans-banner />
<app-footer />
